import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
export const baseProductValidatorSharedMap = {};
/** @public */ export const ProductIdValidator = idValidator("product");
/** @public */ export function createProductValidator(type, props, meta) {
    return T.object({
        id: ProductIdValidator,
        typeName: T.literal("product"),
        type: T.literal(type),
        props: props ? T.object(props) : T.jsonValue,
        meta: meta ? T.object(meta) : T.jsonValue,
        ...baseProductValidatorSharedMap
    });
}
